export default __webpack_public_path__ + "img/Poppins-SemiBold_b532910.woff";